import RegExpObj from '@/utils/regExp.js';
import Service from '@/service/index.js';
import { validateDate } from '@/utils/common.js';
export default {
  props: ['projectInfo'],
  data() {
    const validateDeliveryPeriod = (rule, value, callback) => {
      let type = this.bidGeneralSituation;
      let types = [1, 4, 5, 6, 7]; // 其他类型
      if(!value) {
        callback(new Error('请输入期限'));
      } else {}
      if(!value) {
        callback(new Error('请输入期限'));
      } else if(type === 2 && !RegExpObj.fiftyTime.test(value)) { // 四荒
        callback(new Error('期限1-50年'));
      } else if(type === 3 && !RegExpObj.cbtime.test(value)) { // 林地
        callback(new Error('期限1-70年'));
      } else if(types.includes(type) && !RegExpObj.cbtime.test(value)) {
        callback(new Error('期限1-30年'));
      } else {
        callback();
      }
    };
    const validateStartTime = (rule, value, callback) => {
      if(!value) {
        callback(new Error('请选择开始日期'));
      } else if(validateDate(value, this.totalForm.endTime)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    const validateEndTime = (rule, value, callback) => {
      if(!value) {
        callback(new Error('请选择结束日期'));
      } else if(validateDate(this.totalForm.startTime, value)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    return {
      date: [],
      totalForm: {
        sumArea: null,
        deliveryPeriod: null,
        startTime: '',
        endTime: ''
      },
      deliveryPeriodUnitList: [], // 出租方式
      deliveryPeriodMonthList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],

      isSubletList: [], // 交易方式

      totalFormRules: {
        deliveryPeriodUnit: [
          { required: true, message: '请选择出租方式', trigger: 'change' }
        ],
        deliveryPeriod: [
          { required: true, validator: validateDeliveryPeriod, trigger: 'change' }
        ],
        // startTime: [
        //   { required: true, message: '请选择开始日期', trigger: 'change' }
        // ],
        // endTime: [
        //   { required: true, message: '请选择结束日期', trigger: 'change' }
        // ],
        startTime: [
          { required: true, validator: validateStartTime, trigger: 'change' }
        ],
        endTime: [
          { required: true, validator: validateEndTime, trigger: 'change' }
        ],
        isSublet: [
          { required: true, message: '请选择交易方式', trigger: 'change' }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now(); // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      }
    };
  },
  created () {
    if(this.bidGeneralSituation === 5 || this.bidGeneralSituation === 6) {
      Service.getSelectList('DELIVERY_PERIOD_UNIT').then(res => {
        if (res && res.code === '0') {
          this.deliveryPeriodUnitList = res.data;
        }
      });
      // 交易方式
      Service.getSelectList('MASSIF_TRADE_TYPE').then(res => {
        if (res && res.code === '0') {
          this.isSubletList = res.data;
        }
      });
    }
  },
  watch: {
    // 出租方式
    'totalForm.deliveryPeriodUnit': function(value, oldValue) {
      if (oldValue) {
        this.totalForm.deliveryPeriod = '';
      }
    },
    projectInfo: {
      handler: function(){
        // 建筑物、农机设备 交易方式和按年按月
        if(this.bidGeneralSituation === 5 || this.bidGeneralSituation === 6) {
          this.totalForm = {
            ...this.totalForm,
            deliveryPeriodUnit: '1',
            isSublet: '1'
          };
        }
        // 水面总株数
        if(this.bidGeneralSituation === 3) {
          this.totalForm = {
            ...this.totalForm,
            sumTreeNumber: null
          };
        }
        if(this.projectInfo && this.projectInfo.assetsInfo) {
          const assetsInfoList = JSON.parse(this.projectInfo.assetsInfo);
          let assetsInfo = null;
          assetsInfoList.map(item => {
            if(item.bidGeneralSituation === this.bidGeneralSituation) {
              assetsInfo = item;
            }
          });
          if (assetsInfo) {
            Object.keys(this.totalForm).forEach(key => {
              this.totalForm[key] = assetsInfo[key];
            });
            this.massifs = assetsInfo.massifs;
            this.date = [assetsInfo.startTime, assetsInfo.endTime];
          }
        }
      },
      immediate: true // 初始化执行
    }
  },
  methods: {
    areaVali(rule, value, callback){
      console.log(value, 'value');
      if(value === '' || value === null){
        callback(new Error('请输入地块面积'));
      } else if(value < 0 || value > 9999999.99){
        callback(new Error('请输入0-10000000以内的数字'));
      } else {
        callback();
      }
    },
    onChangeDate (event) {
      this.totalForm.startTime = event && event[0];
      this.totalForm.endTime = event && event[1];
    },
    changeArea (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].area)) {
        return;
      }
      this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area).toFixed(2);
      let num = 0;
      this.massifs.forEach(item => {
        num += Number(item.area);
      });
      this.totalForm.sumArea = num.toFixed(2);
    },
    test(formKey) {
      return new Promise((resolve, reject) => {
        let num = 0;
        this.massifs.forEach((form, index) => {
          form.price = 0;
          this.$refs[`${formKey}${index}`][0].validate((valid) => {
            if (valid) {
              num ++;
            } else {
              reject();
            }
          });
        });
        if (num === this.massifs.length) {
          // 校验发包年限、发包期限
          this.$refs['totalForm'].validate((valid) => {
            if (valid) {
              resolve({
                massifs: JSON.parse(JSON.stringify(this.massifs)),
                ...this.totalForm,
                bidGeneralSituation: this.bidGeneralSituation
              });
            } else {
              reject();
            }
          });
        } else {
          reject();
        }
      });
    }
  }
};
